import * as React from 'react';

import styled from 'styled-components';

import ArtistMenu from '@webapp/controllers/menus/artist-menu';
// import UserSettingsMenu from '@webapp/controllers/menus/user-settings-menu';
import NotificationsMenu from '@webapp/controllers/menus/notifications-menu';

interface NavbarActionsGeneralCtrlProps {
  className?: string;
}

export const NavbarActionsGeneralCtrl: React.FC<NavbarActionsGeneralCtrlProps> = (
  props
) => {
  return (
    <div className={props.className}>
      <ArtistMenu className="navbar-actions-item" />
      <NotificationsMenu className="navbar-actions-item" />
      {/* <UserSettingsMenu className="navbar-actions-item" /> */}
    </div>
  );
};

export default styled(NavbarActionsGeneralCtrl)`
  display: flex;
  align-items: center;

  .navbar-actions-item {
    margin-right: 10px;

    @media ${({ theme }) => theme.device.tablet} {
      margin-right: 16px;

      &:last-child {
        margin: 0;
      }
    }
  }
`;
